var baseStyle = {
  fontSize: "md",
  marginEnd: 3,
  mt: 4,
  mb: 0,
  color: 'secondary',
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
};
export const FormLabel = {
  baseStyle
};
//# sourceMappingURL=form-label.js.map